import type { GuitarChart } from '../guitarChart.js';
import type { Variant } from '../gameTypes.js';
import { PALETTE_TOXIC } from '../builtinPulseMaps/palettes.js';
import { assembleImportedGuitarChart } from './importedGuitarChart.js';
import normalImported from './imported/nekozilla-normal.guitar.json' with { type: 'json' };
import hardImported from './imported/nekozilla-hard.guitar.json' with { type: 'json' };
import extremeImported from './imported/nekozilla-extreme.guitar.json' with { type: 'json' };

export const NEKOZILLA_GUITAR_VARIANTS: Record<Variant, GuitarChart> = assembleImportedGuitarChart({
  baseSlug: 'nekozilla',
  baseTitle: "Howling",
  description: "Cartoon's Howling on Andromedik's DnB remix — [TCD] Dzar03's ranked mania set with five diffs that ramp from beginner-easy to dense Modern streams.",
  difficulty: 5,
  palette: PALETTE_TOXIC,
  audioSrc: '/audio/guitar/nekozilla.mp3',
  attribution: "\"Howling\" by Cartoon (feat. Asena) (Andromedik Remix) [NCS Release] - https://ncs.io/howling",
  imported: {
    normal: normalImported,
    hard: hardImported,
    extreme: extremeImported,
  },
});
